import int01 from "./Introduccion/Intro-01.mp3";
import int02 from "./Introduccion/Intro-02.mp3";
import int03 from "./Introduccion/Intro-03.mp3";
import int04 from "./Introduccion/Intro-04.mp3";
import int05 from "./Introduccion/Intro-05.mp3";
import int06 from "./Introduccion/Intro-06.mp3";
import int07 from "./Introduccion/Intro-07.mp3";

import sub1_act1_a01 from "./Subtema-1/T6-Sub 1-Act 1-A01.mp3";
import sub1_act1_a02 from "./Subtema-1/T6-Sub 1-Act 1-N02.mp3";
import sub1_act1_a03 from "./Subtema-1/T6-Sub 1-Act 1-Y03.mp3";
import sub1_act1_a04 from "./Subtema-1/T6-Sub 1-Act 1-N04.mp3";
import sub1_act1_a05 from "./Subtema-1/T6-Sub 1-Act 1-Y05.mp3";
import sub1_act1_a06 from "./Subtema-1/T6-Sub 1-Act 1-N06.mp3";
import sub1_act1_a07 from "./Subtema-1/T6-Sub 1-Act 1-Y07.mp3";
import sub1_act1_a08 from "./Subtema-1/T6-Sub 1-Act 1-A08.mp3";
import sub1_act1_a09 from "./Subtema-1/T6-Sub 1-Act 1-A09.mp3";
import sub1_act1_a10 from "./Subtema-1/T6-Sub 1-Act 1-A10.mp3";
import sub1_act1_a11 from "./Subtema-1/T6-Sub 1-Act 1-A11.mp3";
import sub1_act1_a12 from "./Subtema-1/T6-Sub 1-Act 1-N12.mp3";
import sub1_act1_a13 from "./Subtema-1/T6-Sub 1-Act 1-Y13.mp3";
import sub1_act1_a14 from "./Subtema-1/T6-Sub 1-Act 1-N14.mp3";
import sub1_act1_a15 from "./Subtema-1/T6-Sub 1-Act 1-A15.mp3";
import sub1_act1_a16 from "./Subtema-1/T6-Sub 1-Act 1-N16.mp3";
import sub1_act1_a17 from "./Subtema-1/T6-Sub 1-Act 1-Y17.mp3";
import sub1_act1_a18 from "./Subtema-1/T6-Sub 1-Act 1-N18.mp3";

import sub2_act1_a01 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-A01.mp3";
import sub2_act1_a02 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-A02.mp3";
import sub2_act1_a03 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-YON03.mp3";
import sub2_act1_a04 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-ANA04.mp3";
import sub2_act1_a05 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-YON05.mp3";
import sub2_act1_a06 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-A06.mp3";
import sub2_act1_a07 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-A07.mp3";
import sub2_act1_a08 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-A08.mp3";
import sub2_act1_a09 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-A09.mp3";
import sub2_act1_a10 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-A10.mp3";
import sub2_act1_a11 from "./Subtema-2/Actividad-1/T6-Sub 2-Act 1-A11.mp3";
import sub2_act2_a01 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-A01.mp3";
import sub2_act2_a02 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-ANA02.mp3";
import sub2_act2_a03 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-YON03.mp3";
import sub2_act2_a04 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-A04.mp3";
import sub2_act2_a05 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-ANA05.mp3";
import sub2_act2_a06 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-YON06.mp3";
import sub2_act2_a07 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-ANA07.mp3";
import sub2_act2_a08 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-A08.mp3";
import sub2_act2_a09 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-A09.mp3";
import sub2_act2_a10 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-ANA10.mp3";
import sub2_act2_a11 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-YON11.mp3";
import sub2_act2_a12 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-A12.mp3";
import sub2_act2_a13 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-ANA13.mp3";
import sub2_act2_a14 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-YON14.mp3";
import sub2_act2_a15 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-A15.mp3";
import sub2_act2_a16 from "./Subtema-2/Actividad-2/T6-Sub 2-Act 2-ANA16.mp3";
import sub2_act3_a01 from "./Subtema-2/Actividad-3/T6-Sub 2-Act 3-A01.mp3";

import sub3_act1_a01 from "./Subtema-3/T6-Sub 3-Act 1-A01.mp3";
import sub3_act1_a02 from "./Subtema-3/T6-Sub 3-Act 1-A02.mp3";
import sub3_act1_a03 from "./Subtema-3/T6-Sub 3-Act 1-A03.mp3";
import sub3_act1_a04 from "./Subtema-3/T6-Sub 3-Act 1-A04.mp3";
import sub3_act2_a01 from "./Subtema-3/T6-Sub 3-Act 2-A01.mp3";
import sub3_act2_a02 from "./Subtema-3/T6-Sub 3-Act 2-A02.mp3";
import sub3_act2_a03 from "./Subtema-3/T6-Sub 3-Act 2-A03.mp3";
import sub3_act2_a04 from "./Subtema-3/T6-Sub 3-Act 2-A04.mp3";
import sub3_act2_a05 from "./Subtema-3/T6-Sub 3-Act 2-A05.mp3";
import sub3_act2_a06 from "./Subtema-3/T6-Sub 3-Act 2-A06.mp3";
import sub3_act2_a07 from "./Subtema-3/T6-Sub 3-Act 2-A07.mp3";
import sub3_act3_a01 from "./Subtema-3/T6-Sub 3-Act 3-A01.mp3";

import sub4_act1_a01 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A01.mp3";
import sub4_act1_a02 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A02.mp3";
import sub4_act1_a03 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A03.mp3";
import sub4_act1_a04 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A04.mp3";
import sub4_act1_a05 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A05.mp3";
import sub4_act1_a06 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A06.mp3";
import sub4_act1_a07 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A07.mp3";
import sub4_act1_a08 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A08.mp3";
import sub4_act1_a09 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A09.mp3";
import sub4_act1_a10 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A10.mp3";
import sub4_act1_a11 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A11.mp3";
import sub4_act1_a12 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A12.mp3";
import sub4_act1_a13 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A13.mp3";
import sub4_act1_a14 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A14.mp3";
import sub4_act1_a15 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A15.mp3";
import sub4_act1_a16 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A16.mp3";
import sub4_act1_a17 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A17.mp3";
import sub4_act1_a18 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A18.mp3";
import sub4_act1_a19 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A19.mp3";
import sub4_act1_a20 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A20.mp3";
import sub4_act1_a21 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A21.mp3";
import sub4_act1_a22 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A22.mp3";
import sub4_act1_a23 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A23.mp3";
import sub4_act1_a24 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A24.mp3";
import sub4_act1_a25 from "./Subtema-4/Actividad-1/T6-Sub 4-Act 1-A25.mp3";
import sub4_act2_a01 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-A01.mp3";
import sub4_act2_a02 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-YON02.mp3";
import sub4_act2_a03 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-ANA03.mp3";
import sub4_act2_a04 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-YON04.mp3";
import sub4_act2_a05 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-ANA05.mp3";
import sub4_act2_a06 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-YON06.mp3";
import sub4_act2_a07 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-ANA07.mp3";
import sub4_act2_a08 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-YON08.mp3";
import sub4_act2_a09 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-ANA09.mp3";
import sub4_act2_a10 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-YON10.mp3";
import sub4_act2_a11 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-A11.mp3";
import sub4_act2_a12 from "./Subtema-4/Actividad-2/T6-Sub 4-Act 2-ANA12.mp3";
import sub4_act3_a01 from "./Subtema-4/Actividad-3/T6-Sub 4-Act 3-A01.mp3";


import sub5_act1_a01 from "./Subtema-5/T6-Sub 5-Act 1-A01.mp3";
import sub5_act1_a02 from "./Subtema-5/T6-Sub 5-Act 1-A02.mp3";
import sub5_act2_a01 from "./Subtema-5/T6-Sub 5-Act 2-A01.mp3";
import sub5_act2_a02 from "./Subtema-5/T6-Sub 5-Act 2-A02.mp3";
import sub5_act2_a03 from "./Subtema-5/T6-Sub 5-Act 2-A03.mp3";
import sub5_act2_a04 from "./Subtema-5/T6-Sub 5-Act 2-A04.mp3";
import sub5_act2_a05 from "./Subtema-5/T6-Sub 5-Act 2-A05.mp3";
import sub5_act2_a06 from "./Subtema-5/T6-Sub 5-Act 2-A06.mp3";
import sub5_act2_a07 from "./Subtema-5/T6-Sub 5-Act 2-A07.mp3";
import sub5_act2_a08 from "./Subtema-5/T6-Sub 5-Act 2-A08.mp3";
import sub5_act3_a01 from "./Subtema-5/T6-Sub 5-Act 3-A01.mp3";
import sub5_act3_a02 from "./Subtema-5/T6-Sub 5-Act 3-A02.mp3";
import sub5_act3_a03 from "./Subtema-5/T6-Sub 5-Act 3-A03.mp3";
import sub5_act3_a04 from "./Subtema-5/T6-Sub 5-Act 3-A04.mp3";
import sub5_act3_a05 from "./Subtema-5/T6-Sub 5-Act 3-A05.mp3";
import sub5_act3_a06 from "./Subtema-5/T6-Sub 5-Act 3-A06.mp3";
import sub5_act4_a01 from "./Subtema-5/T6-Sub 5-Act 4-A01.mp3";


export const T6_voices = {
	introduccion: {
		int01,
		int02,
		int03,
		int04,
		int05,
		int06,
		int07,
	},
	sub01: {
		sub1_act1_a01,
		sub1_act1_a02,
		sub1_act1_a03,
		sub1_act1_a04,
		sub1_act1_a05,
		sub1_act1_a06,
		sub1_act1_a07,
		sub1_act1_a08,
		sub1_act1_a09,
		sub1_act1_a10,
		sub1_act1_a11,
		sub1_act1_a12,
		sub1_act1_a13,
		sub1_act1_a14,
		sub1_act1_a15,
		sub1_act1_a16,
		sub1_act1_a17,
		sub1_act1_a18,
	},
	sub02: {
		sub2_act1_a01,
		sub2_act1_a02,
		sub2_act1_a03,
		sub2_act1_a04,
		sub2_act1_a05,
		sub2_act1_a06,
		sub2_act1_a07,
		sub2_act1_a08,
		sub2_act1_a09,
		sub2_act1_a10,
		sub2_act1_a11,
		sub2_act2_a01,
		sub2_act2_a02,
		sub2_act2_a03,
		sub2_act2_a04,
		sub2_act2_a05,
		sub2_act2_a06,
		sub2_act2_a07,
		sub2_act2_a08,
		sub2_act2_a09,
		sub2_act2_a10,
		sub2_act2_a11,
		sub2_act2_a12,
		sub2_act2_a13,
		sub2_act2_a14,
		sub2_act2_a15,
		sub2_act2_a16,
		sub2_act3_a01,
	},
	sub03: {
		sub3_act1_a01,
		sub3_act1_a02,
		sub3_act1_a03,
		sub3_act1_a04,
		sub3_act2_a01,
		sub3_act2_a02,
		sub3_act2_a03,
		sub3_act2_a04,
		sub3_act2_a05,
		sub3_act2_a06,
		sub3_act2_a07,
		sub3_act3_a01,
	},
	sub04: {
		sub4_act1_a01,
		sub4_act1_a02,
		sub4_act1_a03,
		sub4_act1_a04,
		sub4_act1_a05,
		sub4_act1_a06,
		sub4_act1_a07,
		sub4_act1_a08,
		sub4_act1_a09,
		sub4_act1_a10,
		sub4_act1_a11,
		sub4_act1_a12,
		sub4_act1_a13,
		sub4_act1_a14,
		sub4_act1_a15,
		sub4_act1_a16,
		sub4_act1_a17,
		sub4_act1_a18,
		sub4_act1_a19,
		sub4_act1_a20,
		sub4_act1_a21,
		sub4_act1_a22,
		sub4_act1_a23,
		sub4_act1_a24,
		sub4_act1_a25,
		sub4_act2_a01,
		sub4_act2_a02,
		sub4_act2_a03,
		sub4_act2_a04,
		sub4_act2_a05,
		sub4_act2_a06,
		sub4_act2_a07,
		sub4_act2_a08,
		sub4_act2_a09,
		sub4_act2_a10,
		sub4_act2_a11,
		sub4_act2_a12,
		sub4_act3_a01
	},
	sub05: {
		sub5_act1_a01,
		sub5_act1_a02,
		sub5_act2_a01,
		sub5_act2_a02,
		sub5_act2_a03,
		sub5_act2_a04,
		sub5_act2_a05,
		sub5_act2_a06,
		sub5_act2_a07,
		sub5_act2_a08,
		sub5_act3_a01,
		sub5_act3_a02,
		sub5_act3_a03,
		sub5_act3_a04,
		sub5_act3_a05,
		sub5_act3_a06,
		sub5_act4_a01,
	},
};
